import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Button } from "../../../../../revvComponents";

// Internal Imports

// Actions Import
import {
  coverpageThemeAction,
  updateComponentMeta,
} from "../../../../../actions/DocumentActions";
import { updateToolPaneData } from "../../../../../actions/QuotationActions/QuotationActions";

class ApplyFormulaBtn extends Component {
  state = {};

  _applyFormula = () => {
    this.props.updateComponentMeta({
      ...this.props.activeComponentMeta,
      tableCellEditMode: false,
    });
    this.props.updateDocumentClickedComponentID(
      this.props.section.id,
      true,
      this.props.section.type,
    );
    this.props.updateToolPaneData(true, "doc-components");
    setTimeout(() => {
      this.props.coverpageThemeAction("ApplyTableFormula");
    }, 0);
  };

  _showApplyFormulaOption = () => (
    <div className="managecol-table">
      <Fragment>
        <Tooltip
          placement="bottom"
          overlay="Apply Formula"
          align={{
            offset: [0, 3],
          }}>
          <div
            className={`managecol-table-items ${
              this.props.selectedRowId === null &&
              this.props.selectedColumnId !== null
                ? "disabled-options"
                : ""
            }`}>
            <Button
              data-test="change-form-vew"
              data-name="apply-formula-button"
              className="btn btn-transparent-header"
              onMouseDown={() => {
                this._applyFormula();
              }}>
              <i>
                <FontAwesomeIcon icon={["far", "calculator"]} />
              </i>
              Apply Formula
              <span className="btn-recommend">Beta</span>
            </Button>
          </div>
        </Tooltip>
      </Fragment>
    </div>
  );

  render() {
    return <Fragment>{this._showApplyFormulaOption()}</Fragment>;
  }
}

const mapDispatchToProps = {
  coverpageThemeAction,
  updateToolPaneData,
  updateComponentMeta,
};

export default connect(null, mapDispatchToProps)(ApplyFormulaBtn);
